<template>
  <div class="layout-overlay" @mousedown.self="closeOverlay">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['closeOverlay'])

function closeOverlay() {
  emit('closeOverlay')
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;
.layout-overlay {
  background-color: old-variables.$color-background-navigation-menu;
  display: flex;
  height: calc(100vh - #{variables.$layout-top-bar-height});
  position: fixed;
  top: variables.$layout-top-bar-height;
  left: 0;
  width: 100vw;
  z-index: variables.$z-index-overlay-modal;
}
</style>
